import {Circle, MapContainer, TileLayer} from 'react-leaflet'

export default function TutorProfileLocation({tutorProfile}) {
  const style = {
    width: '100%',
    height: '200px'
  }

  return (
    <>
      <MapContainer center={[tutorProfile.lat, tutorProfile.lon]} zoom={10} style={style}>
        <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png" />
        <Circle center={[tutorProfile.lat, tutorProfile.lon]} radius={2000} />
      </MapContainer>
    </>
  )
}
